import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { LOCALE_ID, NgModule } from '@angular/core';
import { HttpClientModule, HTTP_INTERCEPTORS, HttpClient } from '@angular/common/http';


import { NgbNavModule, NgbAccordionModule, NgbTooltipModule, NgbModule, NgbModalModule } from '@ng-bootstrap/ng-bootstrap';
import { CarouselModule } from 'ngx-owl-carousel-o';
import { ScrollToModule } from '@nicky-lenaers/ngx-scroll-to';



import { ExtrapagesModule } from './extrapages/extrapages.module';

import { LayoutsModule } from './layouts/layouts.module';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';


import { TranslateModule, TranslateLoader } from '@ngx-translate/core';
import { TranslateHttpLoader } from '@ngx-translate/http-loader';


import { AccountModule } from './account/account.module';
import { NgIdleKeepaliveModule } from '@ng-idle/keepalive'; // this includes the core NgIdleModule but includes keepalive providers for easy wireup
import { MomentModule } from 'angular2-moment'; // optional, provides moment-style pipes for date formatting
import { LoggerModule, NgxLoggerLevel } from "ngx-logger";
import { environment } from 'src/environments/environment';

import localEs from '@angular/common/locales/es';
import  { registerLocaleData } from '@angular/common';
import { ToastrModule } from 'ngx-toastr';
import { AuditInterceptor } from './core/interceptor/AuditInterceptor -interceptor';
import { LoadingInterceptor } from './core/helpers/loading.interceptor';
import { SharedModule } from './shared/shared.module';

registerLocaleData(localEs,'es');

export function createTranslateLoader(http: HttpClient): any {
  return new TranslateHttpLoader(http, 'assets/i18n/', '.json');
}

@NgModule({
  declarations: [
    AppComponent
  ],
  imports: [
  BrowserModule,
    BrowserAnimationsModule,
    HttpClientModule,
    TranslateModule.forRoot({
      loader: {
        provide: TranslateLoader,
        useFactory: createTranslateLoader,
        deps: [HttpClient]
      }
    }),
    // LayoutsModule,
    AppRoutingModule,
    ExtrapagesModule,
    SharedModule,
    CarouselModule,
    NgbAccordionModule,
    NgbNavModule,
    NgbTooltipModule,
    NgbModalModule,
    ScrollToModule.forRoot(),
    NgbModule,
    NgIdleKeepaliveModule.forRoot(),
    AccountModule,
    MomentModule,
    LoggerModule.forRoot({
      serverLoggingUrl: `${environment.api}`,
      level:environment.logLevel,
      serverLogLevel: environment.serverLogLevel,
      disableConsoleLogging: false
    }),
    ToastrModule.forRoot({
      timeOut: 10000,
      positionClass: 'toast-bottom-right',
      preventDuplicates: false,
    })
  ],
  bootstrap: [AppComponent],
  providers: [
    { provide:LOCALE_ID, useValue:'es' },
    // { provide: HTTP_INTERCEPTORS, useClass: JwtInterceptor, multi: true },
    // { provide: HTTP_INTERCEPTORS, useClass: ErrorInterceptor, multi: true },
    // { provide: HTTP_INTERCEPTORS, useClass: FakeBackendInterceptor, multi: true },
    // {provide:  LOCALE_ID , useValue :'es-ES'}
    // LoaderService,
    // { provide: HTTP_INTERCEPTORS, useClass: LoaderInterceptorService, multi: true },
    {
    provide: HTTP_INTERCEPTORS,
    useClass: AuditInterceptor,
    multi: true
  },
   {
    provide: HTTP_INTERCEPTORS,
    useClass: LoadingInterceptor,
    multi: true
  }
  ],
})
export class AppModule { }
